<template>
    <div class="exclusive_offer_toast">
      <ns-toast-vue
        custom
        theme="exclusive"
        type="fleeting"
        toast-event-name="showExclusiveOfferDetails"
        duration="10000"
      >
        <template v-slot:custom>
          <ns-message-action
            :message="exclusiveOfferUsedUpQty"
            :action-name="signIn"
            action-type="login"
          >
            <template v-slot:above-message>
              <div class="exclusive_title">
                <ns-icon icon-name="icon-exclusive-offer" />
                <span>{{exclusiveOfferTitle}}</span>
              </div>
            </template>
          </ns-message-action>
        </template>
      </ns-toast-vue>
    </div>
</template>

<script>
import {
  StringService,
} from '@nuskin/ns-util'
import { NsIcon } from '@nuskin/ns-icon'

export default {
  components: { NsIcon },
  data() {
    return {
      exclusiveOfferMessage: '',
      exclusiveOfferUsedUpQty: '',
      signIn: '',
      learnMore: '',
      exclusiveOfferTitle: '',
      secondaryactionurl:
      /* aem.UrlService.checkUrlForExtension(this.tdc.exclusiveProductLearnMoreURL) ||*/ '#',
    }
  },
  mounted() {
    this.setCommonStrings()
  },
  methods: {
    setCommonStrings() {
      const self = this
      const commonStrings = [
        { key: 'exclusiveOfferTitle', dflt: 'Exclusive Offer' },
        {
          key: 'exclusiveOfferMessage',
          dflt: 'This product is only available to qualified users.',
        },
        {
          key: 'exclusiveOfferUsedUpQty',
          dflt: 'You have reached your purchase limit for this product.',
        },
        { key: 'signIn', dflt: 'Sign In' },
        { key: 'learnMore', dflt: 'Learn More' },
      ]
      StringService.getStrings(commonStrings).then((strings) => {
        self.exclusiveOfferTitle = strings.exclusiveOfferTitle
        self.exclusiveOfferMessage = strings.exclusiveOfferMessage
        self.exclusiveOfferUsedUpQty = strings.exclusiveOfferUsedUpQty
        self.signIn = strings.signIn
        self.learnMore = strings.learnMore
      })
    },
  },
}
</script>

<style>
.exclusive_offer_toast .custom {
  background-color: rgba(147, 0, 147, 0.06);
  border-color: transparent;
}

.qualification_transfer_toast .custom {
  display: flex;
  align-items: center;
}

.qualification_transfer_toast .transfer_message {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 10px 0;
  color: #272525;
}

.exclusive_offer_toast .message_action_container {
  background-color: transparent;
}

.exclusive_offer_toast .exclusive_title {
  height: 40px;
  font-size: 18px;
  line-height: 24px;
  color: #272525;
  font-weight: 600;
}

.exclusive_offer_toast .exclusive_title .icon {
  height: 30px;
  width: 40px;
}

.qualification_transfer_toast .transfer_message .icon {
  height: 30px;
  width: auto;
}

.exclusive_offer_toast p {
  margin-top: 35px;
}

.exclusive_offer_toast .message_action {
  margin-top: 26px;
}

@media (min-width: 1024px) {
  .exclusive_offer_toast .custom {
    display: flex;
    align-items: center;
  }

  .exclusive_offer_toast .message_action_container {
    display: flex;
    justify-content: center;
    flex-direction: row;
    margin: 0 auto;
  }

  .exclusive_offer_toast .message_action_container .hide_action {
    width: auto;
  }

  .exclusive_offer_toast .title_message {
    flex-direction: row;
    align-items: center;
  }

  .exclusive_offer_toast .title_message .exclusive_title {
    display: flex;
    align-items: center;
    margin-right: 26px;
  }

  .exclusive_offer_toast .title_message .exclusive_title span {
    margin-left: 5px;
    margin-right: 15px;
  }

  .exclusive_offer_toast .title_message p {
    margin: 0;
    margin-right: 15px;
  }

  .exclusive_offer_toast .message_action,
  .exclusive_offer_toast .secondary_message_action {
    position: relative;
    margin-left: 20px;
    margin-top: 0;
    margin-bottom: 0;
  }

  .exclusive_offer_toast .message_action:hover,
  .exclusive_offer_toast .secondary_message_action:hover {
    cursor: pointer;
  }
}
</style>
